import { FeatureLaunch, isFeatureLaunched } from '@commenda/feature-launches';

import type { InvoiceRequest } from './types';

export class BillingInvoiceHelper {
  static baseUrl(companyId: number): string {
    return isFeatureLaunched(FeatureLaunch.BILLING_READ_FROM_MIRROR, companyId)
      ? 'commenda-billing/mirror'
      : 'billing-new';
  }

  static usesMirror(request: Readonly<InvoiceRequest>): boolean {
    // Backfilled Chargebee invoices keep their original IDs on migrated accounts.
    return (
      request.invoiceId.startsWith('in_') &&
      this.baseUrl(request.companyId) === 'commenda-billing/mirror'
    );
  }

  static invoiceUrl(
    request: Readonly<InvoiceRequest>,
    action?: 'download' | 'preview'
  ): string {
    const query = new URLSearchParams({
      companyId: String(request.companyId),
      invoiceId: request.invoiceId,
    });
    const base = this.usesMirror(request)
      ? 'commenda-billing/mirror'
      : 'billing-new';
    return `${base}/invoice${action ? `/${action}` : ''}?${query}`;
  }
}
